'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarCouponCallout = renderWithRef('PriceBarCouponCallout`', null, (e, t)=>{
    let { children: a } = e;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: new Set([
            'swan-price-bar-coupon-callout'
        ]),
        props: e,
        children: a
    });
});

export { PriceBarCouponCallout };
